// Shared by the browser consent store and middleware. No browser dependencies.
export const CONSENT_VERSION = 1
export const CONSENT_REQUIRED_COUNTRIES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'IS',
  'LI',
  'NO',
  'GB',
])

export function parseConsentRecord(raw) {
  if (!raw || typeof raw !== 'string') return null
  try {
    // Request cookies may still contain the encoding written by js-cookie.
    const value = JSON.parse(
      raw.startsWith('{') ? raw : decodeURIComponent(raw),
    )
    return value?.version === CONSENT_VERSION &&
      typeof value.analyticsConsent === 'boolean'
      ? value
      : null
  } catch {
    return null
  }
}

export function trackingAllowedForRequest(
  country,
  consentCookie,
  forceConsent = false,
) {
  const decision = parseConsentRecord(consentCookie)
  // An explicit withdrawal is respected in every region.
  if (decision) return decision.analyticsConsent
  return (
    !forceConsent &&
    !CONSENT_REQUIRED_COUNTRIES.has((country || 'ZZ').toUpperCase())
  )
}
